import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AcessoMenu from '../../../components/acesso-menu';
import FlexCard from '../../../components/flex-card';
import useDispatchWithResult from '../../../hooks/useDispatchWithResult';
import AuthenticatedLayout from '../../../layouts/authenticated';
import { acessoSelector, fetchAcessos } from '../../../store/acessos';
import { isOperadorSelector } from '../../../store/autenticacao';
import { alertasByEmpresaIdSelector, empresasFiltradasSelector, fetchEmpresas, filtradoSelector, limparEmpresas } from '../../../store/empresas';
import { fetchTabela } from '../../../store/societarioTabela';
import EmpresasTable from './_EmpresasTable';
import PesquisaMenu from "../../../components/pesquisa-menu";
import SocietarioMenu from "../../../components/societario-menu";
import SocietarioFiltroForm from "../filtro/_SocietarioFiltroForm";

export default function SocietarioTabelaPage() {
  const isOperador = useSelector(isOperadorSelector);
  const acesso = useSelector(acessoSelector);
  const empresas = useSelector(empresasFiltradasSelector);
  const filtrado = useSelector(filtradoSelector);
  const alertasByEmpresaId = useSelector(alertasByEmpresaIdSelector);
  const dispatch = useDispatchWithResult();
  const acessoId = acesso?.id;

  useEffect(() => {
    dispatch(fetchAcessos({ modulo: 'societario' }));
  }, []);

  useEffect(() => {
    if (acessoId || filtrado)
      dispatch(fetchEmpresas({ acessoId, modulo: 'societario' }));
    else
      dispatch(limparEmpresas());
  }, [acessoId]);

  useEffect(() => {
    dispatch(fetchTabela({ empresas, alertasByEmpresaId }));
  }, [empresas, alertasByEmpresaId]);

  return (
    <AuthenticatedLayout
      modulo="societario"
      menu={
        <>
          <AcessoMenu allowClear defaultRoute="/societario/tabela" fetchEmpresas modulo="societario"/>
          {acessoId > 0 && <PesquisaMenu/>}
          <SocietarioMenu showCreate={isOperador} showFilter/>
        </>
      }
    >
      <FlexCard>
        <SocietarioFiltroForm/>
        <EmpresasTable/>
      </FlexCard>
    </AuthenticatedLayout>
  );
}
